if (typeof window !== 'undefined') {
	window.Headroom = window.Headroom || function () { this.init = function () {}; };
}

import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;
import {initSwiper} from "./modules/sliders";
import {initAccordion} from "./modules/accordion";
import {initAjaxLoadMore} from "./modules/ajax-load-more";
import {initSlickCarousel} from "./modules/slick";
import {initHeadroom, initHeaderVisibility} from "./modules/headroom";
import {initKameleoon, initPhoneKameleoon} from "./modules/kameleoon-bundle";
import {initExperienceSlider} from "./modules/experience-slider";


// -------------------------------------------------------------
// DOM Ready
// -------------------------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  initSwiper();
  initAccordion();
  initSlickCarousel();
  initHeadroom();
  initHeaderVisibility();
  initKameleoon();
  initPhoneKameleoon();
  initExperienceSlider();
  removeCountryFlagOnWindows();
});

const originalAlmOnLoad = window.almOnLoad;
window.almOnLoad = function(){
  if (typeof originalAlmOnLoad === 'function') {
    originalAlmOnLoad();
  }

  // skipStart: true évite un second appel à l’API cache ALM (le plugin a déjà chargé le contenu).
  initAjaxLoadMore({ skipStart: true });
};

const removeCountryFlagOnWindows = () => {
  const modal = document.querySelector('.modal-expert');
  const isWindows = window.navigator.userAgent.includes('Windows');
  if (!isWindows || !modal) return;

  const modalBody = document.querySelector('.modal-offcanvas__body');
  modalBody.innerHTML = modalBody.innerHTML.replace(/[\u{1F1E6}-\u{1F1FF}]{2}/gu, '');
};
